export default __webpack_public_path__ + "static/media/element_48.791a67e3.avif";